// hooks/useLocalPageData.js
import { useState, useEffect } from 'react';
import localPagesData from '../data/pages_locales_agence_web.json';

export const useLocalPageData = (slug) => {
    const [state, setState] = useState({
        data: null,
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchData = () => {
            try {
                if (!slug) {
                    setState({
                        data: null,
                        loading: false,
                        error: 'Slug non fourni'
                    });
                    return;
                }

                // Normaliser le slug de l'URL
                const normalizedSlug = slug.toLowerCase().trim();

                // Recherche soit par url_slug complet, soit par correspondance avec la ville normalisée
                const pageData = localPagesData.find(page => {
                    // Normaliser le nom de la ville pour correspondance
                    const normalizedCity = page.ville.toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .replace(/\s+/g, '-')
                        .replace(/[^a-z0-9-]/g, '-')
                        .replace(/-+/g, '-')
                        .replace(/^-|-$/g, '');

                    return page.url_slug === normalizedSlug || normalizedCity === normalizedSlug;
                });

                if (pageData) {
                    setState({
                        data: pageData,
                        loading: false,
                        error: null
                    });
                } else {
                    setState({
                        data: null,
                        loading: false,
                        error: 'Page non trouvée'
                    });
                }
            } catch (error) {
                setState({
                    data: null,
                    loading: false,
                    error: 'Erreur lors du chargement de la page'
                });
            }
        };

        fetchData();
    }, [slug]);

    return state;
};

export default useLocalPageData;